import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

/** sessionStorage-nyckel – delas med ev. global hanterare i main.tsx */
export const CHUNK_RELOAD_STORAGE_KEY = 'vite-chunk-reload-once';

function isChunkLoadError(err: unknown): boolean {
  const msg = err instanceof Error ? err.message : String(err);
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module') ||
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError') ||
    msg.includes('Unable to preload CSS')
  );
}

/**
 * React.lazy som vid utdaterade chunks (efter deploy) gör en omladdning så att
 * index.html + nya filnamn hämtas. Vanlig orsak till felet du såg i konsolen.
 */
export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>
): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      const mod = await factory();
      try {
        sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY);
      } catch {
        /* privat läge / storage blockerad */
      }
      return mod;
    } catch (err) {
      if (typeof window !== 'undefined' && isChunkLoadError(err)) {
        try {
          if (!sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY)) {
            sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, '1');
            window.location.reload();
            return new Promise(() => {}) as Promise<{ default: T }>;
          }
          sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY);
        } catch {
          /* ignore */
        }
      }
      throw err;
    }
  });
}
